import { OrbitComponent } from '../base-components/orbit-component/orbit-component';
import { GameItemComponent } from '../game-item/game-item.component';
import { IdleRecommendationToasterBox } from './boxes/idle-recommendation-toaster.box';
import { IdleRecommendationHeaderBox } from './boxes/idle-recommendation-header.box';
import { IdleRecommendationHeaderTitleWrapperBox } from './boxes/idle-recommendation-header-title-wrapper.box';
import { IdleRecommendationGameDetailsBox } from './boxes/idle-recommendation-game-details.box';
import { IdleRecommendationToasterBackgroundBox } from './boxes/idle-recommendation-toaster-background.box';
import { StandardToastTitleBox } from '../toaster/toasts-content/boxes/standard-toast-title/standard-toast-title.box';
import { StandardToastMessageBox } from '../toaster/toasts-content/boxes/standard-toast-message/standard-toast-message.box';

interface IdleRecommendationsComponentProps {
    gameType: number;
    onPlayRecommendedGame(): void;
}


export class IdleRecommendationComponent extends OrbitComponent<IdleRecommendationsComponentProps> {
    render() {
        return <IdleRecommendationToasterBox>
            <IdleRecommendationHeaderBox>
                <IdleRecommendationHeaderTitleWrapperBox>
                    <StandardToastTitleBox>{this.services.translation.translate('IDLE_RECOMMENDATIONS_TITLE')}</StandardToastTitleBox>
                    <StandardToastMessageBox>{this.services.translation.translate('IDLE_RECOMMENDATIONS_SECOND_TITLE')}</StandardToastMessageBox>
                </IdleRecommendationHeaderTitleWrapperBox>
            </IdleRecommendationHeaderBox>
            <IdleRecommendationGameDetailsBox>
                <GameItemComponent
                    gameType={this.props.gameType}
                    onClickHandler={this.props.onPlayRecommendedGame}
                />

                <IdleRecommendationToasterBackgroundBox className="toaster-background-image" />
            </IdleRecommendationGameDetailsBox>
        </IdleRecommendationToasterBox>;
    }
}
